var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "language-dropdown-container",
      class: _vm.containerClasses.join(" ")
    },
    [
      _c(
        "div",
        {
          ref: "languagesDropdown",
          class: [
            "language-options-dropdown",
            { "landing-page-option": _vm.$route.fullPath.includes("/landing") }
          ]
        },
        _vm._l(_vm.languages, function(language, index) {
          return _c(
            "span",
            {
              key: index,
              staticClass: "language-option",
              on: {
                click: function($event) {
                  return _vm.handleDropDownClick(language)
                }
              }
            },
            [
              _c("img", {
                staticClass: "flag",
                attrs: {
                  src: require(`@/common/assets/icons/flags/${language.short.toLowerCase()}.svg`),
                  alt: language.name
                }
              }),
              _c("span", [_vm._v(_vm._s(language.name))]),
              _c("img", {
                staticClass: "arrow",
                attrs: {
                  src: require(`@/drc/assets/icons/arrows/arrow-down-${
                    _vm.containerClasses.includes("dark-mode")
                      ? "white"
                      : "gray"
                  }.svg`),
                  alt: "lang"
                }
              })
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }